import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import GetCurrenciesQuery from '../../components/Query/Currencies';
import Catalog from './Catalog';

interface IPaymentMethodsProps extends RouteComponentProps<{
  eshop: string;
  paymentMethodId: string;
}> {

}

export default class CatalogPage extends React.Component<IPaymentMethodsProps> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <GetCurrenciesQuery>
        {({ primaryCurrency }) => (
          <div>
            <Catalog
              domain={this.props.match.params.eshop}
              currency={primaryCurrency}
            />
          </div>)}
      </GetCurrenciesQuery>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Catalog/index.tsx